import React , {useEffect , useState} from 'react';
import './MostPlacesSection.css';
import { getDocs , collection , db  } from '../firebase';
import Aos from 'aos';
import "aos/dist/aos.css";
import { Link } from 'react-router-dom';


const MostPlacesSection = () => {

        useEffect(() => {
                Aos.init( {  duration: 1200 } )
              } , []);

              const [ supportedPlaces , setSupportedPlaces ] = useState([]);

              useEffect(  () => {
              
                
                const getSupportedPlaces = async () => { 
                  const querySnapshot = await getDocs(collection(db, "supported_places"));
                  const placesDataArray = querySnapshot.docs
                  .map((doc) => ({ ...doc.data(), id: doc.id }));
                    
                  setSupportedPlaces(placesDataArray);
                 
                }
                getSupportedPlaces();
              } , []);

  return (
    <div>
        <div className="grid_places mt-4">

     
  {supportedPlaces && supportedPlaces.map(({  id , place_headline , place_photo,  place_desc }) => (

<div className="single_experince_div " data-aos-duration="450"   data-aos="slide-right" data-aos-delay="10" data-aos-easing="linear" data-aos-mirror="true" >

    <Link to={`/places/${id}`} >

   
<img src={place_photo} alt="" className="experince_img" />
</Link>

<div className=" body_experince_card">
<p className="location_experince_sm mt-1-small"  > {place_headline} </p>

<p className="location_experince_sm mt-1-small color_black"> {place_desc.substring(0 , 60)}... </p>

<Link to={`/places/${id}`} >
<div className="d-flex-c f-sp">
<button className="btn_category_sm ">   أعرف اكثر </button>
<img src="/images/icons/left-arrow-purple.png" alt="" className="icon_experince" />
</div>

</Link>

</div>

</div>
))}




        </div>
    </div>
  )
}

export default MostPlacesSection